import FunnelLogo from "@components/quiz/FunnelLogo"
import { ArrowLeftIcon } from "@heroicons/react/24/outline"
import { useTranslation } from "react-i18next"

/**
 * Logo header with an optional back button, for funnel pages that sit outside
 * the quiz progress (checkout, account, error states).
 */
export default function FunnelHeader({ onBack }: { onBack?: () => void }) {
  const { t } = useTranslation()

  return (
    <header className="vm-container grid h-16 grid-cols-[40px_1fr_40px] items-center">
      {onBack ? (
        <button
          aria-label={t("shared.back")}
          className="flex h-10 w-10 items-center justify-center rounded-full text-vm-ink transition-colors hover:bg-vm-line"
          onClick={onBack}
          type="button"
        >
          <ArrowLeftIcon className="h-5 w-5" />
        </button>
      ) : (
        <span />
      )}

      <div className="flex justify-center">
        <FunnelLogo />
      </div>
    </header>
  )
}
